import { conversionTools } from "./conversion-tools";
import { socialMediaTools } from "./social-media-tools";
import { optimizationTools } from "./image-optimization-tools";
import { seoTools } from "./image-seo-tools";
import { analysisTools } from "./image-analysis-tools";
import { editingTools } from "./image-editing-tools";
import { pdfTools } from "./pdf-tools";
import { securityTools } from "./security-tools";
import { toolCategories } from "./categories";
import type { ResolvedToolDefinition } from "./types";
import { assertValidToolRegistry } from "./validation";

export { conversionTools } from "./conversion-tools";
export { socialMediaTools } from "./social-media-tools";
export { optimizationTools } from "./image-optimization-tools";
export { seoTools } from "./image-seo-tools";
export { analysisTools } from "./image-analysis-tools";
export { editingTools } from "./image-editing-tools";
export { pdfTools } from "./pdf-tools";
export { securityTools } from "./security-tools";
export { toolCategories } from "./categories";
export type { ToolIconKey } from "./icon-keys";
export type {
  ResolvedToolDefinition,
  ToolBenefit,
  ToolCalloutGroup,
  ToolCategoryDefinition,
  ToolContentListItem,
  ToolDefinition,
  ToolFaq,
  ToolFaqSectionText,
  ToolHeroBadge,
  ToolIntroBlock,
  ToolIntroCodeBlock,
  ToolIntroContent,
  ToolPageSections,
  ToolPageContent,
  ToolReferenceTable,
  ToolSectionText,
  ToolStep,
  ToolType,
} from "./types";

export const tools: ResolvedToolDefinition[] = [
  conversionTools,
  socialMediaTools,
  optimizationTools,
  seoTools,
  analysisTools,
  editingTools,
  pdfTools,
  securityTools,
]
  .flat()
  .map((tool) => ({
    ...tool,
    heroBadges: tool.heroBadges ?? [],
  }));

assertValidToolRegistry(tools, toolCategories);

export const toolMap = new Map(tools.map((tool) => [tool.slug, tool] as const));
export const toolCategoryMap = new Map(
  toolCategories.map((category) => [category.slug, category] as const),
);

export function getToolBySlug(slug: string) {
  const tool = toolMap.get(slug);

  if (!tool) {
    throw new Error(`Unknown tool slug: ${slug}`);
  }

  return tool;
}

export function getToolCategoryBySlug(slug: string) {
  const category = toolCategoryMap.get(slug);

  if (!category) {
    throw new Error(`Unknown tool category slug: ${slug}`);
  }

  return category;
}
